
<template>
  <v-container fluid no-gutters pa-3 :style="{marginTop:(annidamento?'0.2em':'0.7em')}">
    <v-col cols="12" align="center" v-if="gruppo.piatti && gruppo.piatti.length>0">
      <h3
        class="font-weight-light"
        :style="{fontSize:annidamento?(1-annidamento*0.08)+'em':'1.5em'}"
      >
        <v-badge :value="contatoregruppo>0" color="red" :content="contatoregruppo">{{traduzionepiatto(gruppo,$store.state.currentlan)}}</v-badge>
        <span style="visibility: hidden">{{gruppo.idsottogruppo}}</span>
      </h3>
    </v-col>
    <v-col
      v-for="piatto in gruppo.piatti"
      :key="piatto.descrizione"
      cols="12"
      lg="12"
      align="center"
    >

      <!--<Piatto :piatto="piatto" :canadd="gruppo.canadd?gruppo.canadd:true" :raggruppamento="gruppo" :flat_menu = "flat_menu" :show_images = "show_images" :enable_orders="enable_orders" @ordinapiatto="ordinapiatto($event)"></Piatto>-->
      <!-- Fine Inizio Piatto -->

      <v-card style="padding:2px;margin:1px" dense :flat="flat_menu">
        <v-row align="center" no-gutters>
          <v-col cols="12" sm="2" align="left" v-if="show_images">
            <v-img
              :src="piatto.url|| 'http://www.lacervarola.it/wp-content/uploads/2015/09/icona-ristorante.png'"
              width="100%"
              :height="$vuetify.breakpoint.name!='xs'?'100%':'75px'"
              aspect-ratio="1"
            ></v-img>
          </v-col>
          <v-col cols="8" sm="8"  align="left" justify="center">
            <h2 class="font-weight-light" style="font-size:1.1em"><v-badge :value="contatorepiatto(piatto)>0" color="red" :content="contatorepiatto(piatto)">{{traduzionepiatto(piatto,$store.state.currentlan)}}</v-badge></h2>
            <div>
              <span
                class="font-weight-light font-italic"
                style="font-size:0.7em"
                v-for="(ingrediente,index) in piatto.ingredienti"
                :key="index"
              >{{index > 0?',':''}} {{ingrediente.descrizione}}{{ingrediente.allergenico=='-1'?'*':''}}</span>
            </div>
          </v-col>
          <v-col cols="4" sm="4" align="right" >
            <h3 v-if="show_prices" align="right" style="font-size:1.1em">€ {{piatto.prezzo/100}}</h3>
            <v-btn
              v-if="enable_orders && gruppo.piattinonprenotabili && contatorepiatto(piatto)>0"
              small
              color="secondary"
              @click=" rimuovipiatto(piatto)"
            >
              <v-icon>mdi-minus
              </v-icon>
              
            </v-btn>
            <v-btn
              v-if="enable_orders && gruppo.piattinonprenotabili=='0' && gruppocanadd(gruppo)"
              small
              color="orange"
              @click=" ordinapiatto(piatto)"
            >
              <v-icon>mdi-plus
              </v-icon>
              
            </v-btn>
          </v-col>
          <template v-for="(a,p) in piatti_carrello(piatto)" >

            <v-col cols="11" offset="1" :key="p">
              <v-text-field 
              dense
              clearable
              v-model="a.variazioni"
              prepend-icon="edit"

              :hint="'note x '+a.descrizione +' n.'+(p+1) "></v-text-field>
            </v-col>
          </template>
        </v-row>
      </v-card>
      <!-- Fine Piatto -->
    </v-col>
    <v-row v-for="grp in gruppo.sottogruppi" :key="grp.idsottogruppo">
      <raggruppamento-piatti
        :gruppo="grp"
        :gruppoprincipale="grp.gruppoprincipale"
        :flat_menu="flat_menu"
        :show_images="show_images"
        :show_prices="show_prices"
        :enable_orders="enable_orders"
        :annidamento="annidamento?annidamento+1:1"
        @ordinapiatto="ordinapiatto($event)"
        @rimuovipiatto="rimuovipiatto($event)"
      ></raggruppamento-piatti>
    </v-row>
  </v-container>
</template>
<script>
/* eslint-disable vue/no-unused-components */
import Piatto from "./Piatto.vue";

export default {
  name: "raggruppamentopiatti",
  components: {
    Piatto
  },
  props: [
    "gruppo",
    "nospiti",
    "show_images",
    "show_prices",
    "flat_menu",
    "enable_orders",
    "annidamento"
  ],
  data: () => ({}),
  computed: {
    contatoregruppo(){   
      return this.$store.state.carrello.piatti.filter(p=>p.sottogruppo.idsottogruppo == this.gruppo.idsottogruppo).length
    },


  },
  methods: {
    gruppocanadd(gruppo){
      if(((this.$store.state.reservation && this.$store.state.reservation.id =='0') || gruppo.verificanumospiti=='0') )
        return true
      else
        return this.contatoregruppo <= this.$store.state.nospiti
    },
    contatorepiatto(piatto){   
      return this.$store.state.carrello.piatti.filter(p=>p.idpiatto == piatto.idpiatto).length
    },
    traduzionepiatto(piatto,lingua){
      //console.log("traduzione piatto:",piatto,lingua)
      var testo = ''
      if(piatto){
        testo = piatto.descrizione
        if(lingua && lingua != 'it'){
          var trad =piatto['descrizione_'+lingua.toUpperCase()]
          if(trad && trad.length > 0)
            testo = trad
        }
      }
      return testo;
    },
    // eslint-disable-next-line no-unused-vars
    piatti_carrello(piatto){
      var ret =this.$store.state.carrello.piatti.filter(p=>p.idpiatto == piatto.idpiatto)
      //console.log(piatto,this.$store.state.carrello.piatti)

      return ret;

    },
    componipiatto(piatto) {
      let p = piatto;
      
      if (!piatto.sottogruppo) {
        piatto.sottogruppo = {ordinato:0,idsottogruppo:this.gruppo.idsottogruppo};
      }
      return p;
    },
    ordinapiatto(piatto) {
      //console.log("ordina", piatto,this.contatoregruppo)
      //console.log("ordina2", this.contatoregruppo)
      //this.$emit("ordinapiatto", piatto,);
      this.$emit("ordinapiatto", this.componipiatto(piatto));
      
      //per refresh...
      let a =piatto.descrizione;
      piatto.descrizione=""
      piatto.descrizione=a

      //piatto.sottogruppo.idsottogruppo++; //per far effettuare refresh
    },
    rimuovipiatto(piatto) {
      console.log("rimuovi", piatto)
      this.$emit("rimuovipiatto", piatto);

      //per refresh...
      let a =piatto.descrizione;
      piatto.descrizione=""
      piatto.descrizione=a
      //piatto.sottogruppo.idsottogruppo++; //per far effettuare refresh
    },
    ordinato(piatto) {
      if (piatto.sottogruppo && piatto.sottogruppo.ordinato) {
        return piatto.sottogruppo.ordinato;
      } else {
        return 0;
      }
    },

    
  }
};
</script>
